export const addClass = function (el) {
    const className = el.getAttribute("data-class");
    const targetSelector = el.getAttribute("data-target");

    if (typeof targetSelector != "undefined") {
        if (targetSelector === "parent") {
            el = el.parentNode;
        }
    }

    if (el.classList.contains(className)) {
        el.classList.remove(className);
    } else {
        el.classList.add(className);
    }
};
